import axios from "axios";
import $ from "jquery";
import {bindModalCloseEvents, modalInitialize} from "../../modals/render-modal";
import {isMobile} from "Core/screenSizes";
import {AD_HEADER_MENU, AD_POPUP} from "Core/links";
import {
    adViewAndClickHandlers,
    changeAdFox,
    changeParentBlock,
    getAdsMapByPlace,
    getExceptedAdsIdBySessionPlace
} from "../general-handlers";

const PLACE = 'popup';
const MOBILE_PLACE = 'mobile_popup';

export const showAdPopup = () => {
    axios.get(AD_HEADER_MENU, {})
        .then((response) => {
            if (!response.data.length) {
                return;
            }

            $('.header-menu').append(response.data);

            adViewAndClickHandlers();
        });

    if (window.isHideAds !== undefined) {
        if (!isMobile() && window.isHideAds[PLACE] !== undefined) {
            return;
        }

        if (isMobile() && window.isHideAds[MOBILE_PLACE] !== undefined) {
            return;
        }
    }

    const place = isMobile() ? MOBILE_PLACE : PLACE;

    axios.get(AD_POPUP, {
        params: {
            isMobile: isMobile(),
            mapViews: getAdsMapByPlace(place),
            exceptedIdList: getExceptedAdsIdBySessionPlace(place),
        }
    })
        .then((response) => {
            if (!response.data.length) {
                return;
            }

            const modalSelector = '#ad-popup';
            const width = $(modalSelector).css('width');
            const height = $(modalSelector).css('height');

            let str = changeAdFox(response.data);
            let toBody = str.indexOf('data-is-without-block="1"') !== -1;
            str = changeParentBlock(str);

            if (toBody) {
                $('.ad-popup').replaceWith(str);
            } else {
                modalInitialize(str, modalSelector, '.ad-popup');
                bindModalCloseEvents(modalSelector);
                $('.modal-open').css('overflow', 'auto');
                $(modalSelector).css({'width': width, 'height': height});

                if (str.indexOf('adfox') === -1) {
                    $('#ad-popup').show();
                }
            }

            adViewAndClickHandlers();
        });
};
